<template>
  <div>
    <div class="msg printhide">
      <b>Let op!</b> Zorg dat de u-rendement waarde van deze maand klopt:
      <a target="_blank" href="https://www.pensioenperspectief.nl/kerncijfers/u-rendement/">
        maandelijks u-rendement
      </a>
    </div>

    <div v-if="duration > 20" class="msg printhide">
      <b>Pas op!</b>
      Leefrente kan niet worden aangeboden voor AOW leeftijd en/of sommige nabestaanden.
    </div>

    <div class="menubar row printhide">
      <div class="dropdown nowrap" style="float:left;">
        <button class="dropdown-button" @click="dropdownlistType = true">
          {{type}}. {{ types[type] }} <awesomeIcon icon="caret-down" />
        </button>
        <div class="dropdown-bg" v-if="dropdownlistType" @click="dropdownlistType = false"></div>
        <ul class="dropdown-list" v-if="dropdownlistType">
          <li
            v-for="(groupname, group) in types"
            :key="groupname.id"
            @click="
              type = group;
              dropdownlistType = false;
            "
          >
            {{ groupname }}
          </li>
          <li class="dropdown-cancel" @click="dropdownlistType = false">Annuleren</li>
        </ul>
      </div>

      <input
        type="text" v-model="target"
        :placeholder="`${type == '1'
          ? 'Leefrente doel'
          : type == '4'
          ? 'Lijfrente doel'
          : 'Uitkering per jaar'}`"
        v-if="type == '1' || type == '3' || type == '4'"
        style="float:left;width:160px;border-right:none;border-radius:0;"
      />

      <input
        type="text"
        v-model="amount"
        placeholder="Startbedrag"
        style="float:left;width:80px;border-right:none;border-radius:0;"
      />
      <input
        v-if="type == '0' || type == '1' || type == '4'"
        type="text"
        v-model="urendement"
        placeholder="U-Rendement"
        style="float:left;width:80px;border-right:none;border-radius:0;"
      />

      <div class="dropdown" style="float:left;">
        <button class="dropdown-button" @click="dropdownlistDuration = true">
          <b>Duur</b> {{ durations[duration] }} <awesomeIcon icon="caret-down" />
        </button>
        <div class="dropdown-bg" v-if="dropdownlistDuration" @click="dropdownlistDuration = false">
        </div>
        <div class="dropdown-list" v-if="dropdownlistDuration">
          <ul class="list">
            <li
              v-for="(groupname, group) in durations"
              :key="groupname.id"
              @click="
                duration = group;
                dropdownlistDuration = false;
              "
            >
              {{ groupname }}
            </li>
          </ul>
          <div class="dropdown-cancel" @click="dropdownlistDuration = false">Annuleren</div>
        </div>
      </div>

      <button @click="windowPrint" style="float:right;"><awesomeIcon icon="print"/></button>

      <button @click="settingsModal = true" style="float:right;">
        <awesomeIcon icon="cog" />Instellingen
      </button>

    </div>

    <div class="msg printhide" v-if="errorText">
      <awesomeIcon icon="exclamation-circle" size="lg" style="margin-right: 10px;" />
      <b>Indicatie mislukt</b>
      <br /><br /><span v-html="errorText" />
    </div>

    <modalWindow v-show="settingsModal" @close="settingsModal = false" width="400">
      <div class="titlebar">Instellingen</div>
      <form style="padding:20px;">
        <select name="brand" v-model="style">
          <option
            v-for="(name, value) in brands"
            :key="value"
            :value="value"
          >
            {{name}}
          </option>
        </select>
        <br><br><b>Indicatief uitkeringsschema</b>
        <select name="brand" v-model="profile">
          <option
            v-for="(name, value) in profiles"
            :key="value"
            :value="value"
          >
            Profiel {{name}}
          </option>
        </select>
        <select name="forhands" v-model="forehand">
          <option value="0" selected>achteraf</option>
          <option value="1">vooraf</option>
        </select>
        <select name="paymentperiod" v-model="paymentPeriod">
          <option value="maand" selected>per maand</option>
          <option value="kwartaal">per kwartaal</option>
          <option value="halfjaar">per half jaar</option>
          <option value="jaar">per jaar</option>
        </select>
      </form>
    </modalWindow>

    <template v-if="!errorText && !calculating && calculation.charts.chart2">
      <leefrentePageOverview
        v-if="type == '0' || type == '1' || type == '4'"
        :amount="Number(amount)"
        :duration="Number(duration)"
        :offerType="Number(type)"
        :paymentPeriod="paymentPeriod"
        :charts="calculation.charts"
        :profile="Number(profile)"
      />
      <leefrentePageCharts
        v-if="type == '0' || type == '1' || type == '4'"
        :duration="Number(duration)"
        :offerType="Number(type)"
        :charts="calculation.charts"
        :profile="Number(profile)"
      />

      <goudenhanddrukPageOverview
        v-if="type == '2' || type == '3'"
        :amount="Number(amount)"
        :duration="Number(duration)"
        :offerType="Number(type)"
        :paymentPeriod="paymentPeriod"
        :charts="calculation.charts"
        :looptijd="Object.assign({}, calculation.looptijd)"
        :target="Number(target)"
        :profile="Number(profile)"
      />

      <div
        v-if="type != '3'"
        class="card printhide" style="padding:40px"
      >
        <h3>Admin</h3>
        Startbedrag
        <strong>
          &euro; {{ formatPrice(Number(amount), true) }},-
        </strong><br>
        Eerste uitkering(bruto)
        <strong>
          &euro;
          {{
            formatPrice(
              Number(type == '1' || type == '4'
                ? calculation.charts.chart2[0][2] : type == '2'
                  ? calculation.charts.chart1[0][2] : calculation.charts.chart2[1][1]),
              true,
            )
          }},-
        </strong>
        (&euro;
        {{
          formatPrice(
            Number(type == '1' || type == '4'
              ? calculation.charts.chart2[0][2] : type == '2'
                ? calculation.charts.chart1[0][2] : calculation.charts.chart2[1][1]) / 12,
            true,
          )
        }},- per maand)<br />
        Looptijd <strong>{{ Number(duration) }} jaar</strong><br />
        Gebruikt Voorbeeldrendement:&nbsp;<span>{{ profile }}</span>%<br />
        Gebruikt U-rendement:&nbsp;<span>{{ formatPrice(Number(urendement)) }}</span>%<br /><br />

        <form @submit.prevent v-if="type !== '2'">
          <strong>Koopsompolissen:</strong><br />
          Port: <input v-model="port" />
          <button @click="save">Opslaan</button>
        </form>

        <template v-if="type == '1' || type == '4'">
          <table class="new">
            <tr>
              <th>Looptijd</th>
              <th>Koopsom jaar 1</th>
              <th>Verdeling jaar 1</th>
              <th>Uitkering 1</th>
            </tr>
            <tr v-for="(waarde, index) in filter(calculation.polissen)" :key="index">
              <th>
                {{ Number(duration) - index }} jaar
                <span v-if="Number(duration) - index < 20">*</span>
              </th>
              <td>&euro;{{ formatPrice(waarde) }}</td>
              <td>{{ formatPrice((waarde / Number(amount)) * 100) }}%</td>
              <td>
                &euro;{{
                  formatPrice(
                    PMT(Number(urendement) / 100, Number(duration) - index, -waarde, 0, forehand),
                  )
                }}
              </td>
            </tr>
            <tr>
              <th>* tijdelijke {{ quotationType }} units:</th>
              <td colspan="2"></td>
              <td>&euro;{{ formatPrice(calculation.shortUnits) }}</td>
            </tr>
          </table>
        </template>

        <template v-else-if="type == '0'">
          <table class="new">
            <tr>
              <th>Looptijd</th>
              <th>Koopsom</th>
              <th>Eerste uitkering<span v-if="Number(duration) < 20"> (units)</span></th>
            </tr>
            <tr>
              <th>{{ duration }} jaar</th>
              <td>&euro;{{ formatPrice(Number(amount)) }}</td>
              <td>
                &euro;{{
                  formatPrice(
                    PMT(Number(urendement) / 100, Number(duration), -Number(amount), 0, forehand),
                  )
                }}
              </td>
            </tr>
          </table>
        </template>

        <br /><br />
        <strong>Verloop</strong>
        <table class="new">
          <tr>
            <th></th>
            <th>Begin</th>
            <th>Rendement</th>
            <th>Uitkering</th>
            <th>Slot</th>
          </tr>
          <tr v-for="(waarde, index) in renderVerloop" :key="index">
            <th>{{ index + 1 }}</th>
            <td>&euro;{{ formatPrice(waarde.start, true) }}</td>
            <td>&euro;{{ formatPrice(waarde.profit, true) }}</td>
            <td>&euro;{{ formatPrice(waarde.uitkering, true) }}</td>
            <td>&euro;{{ formatPrice(waarde.end, true) }}</td>
          </tr>
        </table>
      </div>
    </template>
    <div v-else-if="calculating" class="loader" />

  </div>
</template>

<script>
/* eslint-disable */
import { filter } from 'lodash-es';
import leefrentePageOverview from './../offers/intake/leefrentePageOverview';
import leefrentePageCharts from './../offers/intake/leefrentePageCharts';
import goudenhanddrukPageOverview from './../offers/intake/goudenhanddrukPageOverview';

export default {
  components: {
    leefrentePageOverview,
    leefrentePageCharts,
    goudenhanddrukPageOverview,
  },
  name: 'OfferPage',
  data() {
    return {
      calculation: { charts: {}},
      errorText: '',
      calculating: false,
      port: '',
      settingsModal: false,
      amount: '50000',
      urendement: -0.29,
      target: '',
      paymentPeriod: 'jaar',
      style: process.env.VUE_APP_STYLE,
      forehands: {
        '1': 'Vooraf',
        '0': 'Achteraf',
      },
      types: {
        '4': 'Netto lijfrente',
        '3': 'GH vaste uitkering',
        '2': 'GH vaste looptijd',
        '1': 'Leefrente',
        '0': 'Normaal',
      },
      type: '1',
      brands: {
        vm: 'Velthuyse • Mulder',
        bvs: 'Beer & Van Stapele',
        db: 'Doelbeleggen',
        ox: 'OXBY',
      },
      durations: {
        5: '5 jaar',
        6: '6 jaar',
        7: '7 jaar',
        8: '8 jaar',
        9: '9 jaar',
        10: '10 jaar',
        11: '11 jaar',
        12: '12 jaar',
        13: '13 jaar',
        14: '14 jaar',
        15: '15 jaar',
        16: '16 jaar',
        17: '17 jaar',
        18: '18 jaar',
        19: '19 jaar',
        20: '20 jaar',
        21: '21 jaar',
        22: '22 jaar',
        23: '23 jaar',
        24: '24 jaar',
        25: '25 jaar',
        26: '26 jaar',
        27: '27 jaar',
        28: '28 jaar',
        29: '29 jaar',
        30: '30 jaar',
        31: '31 jaar',
        32: '32 jaar',
        33: '33 jaar',
        34: '34 jaar',
        35: '35 jaar',
        36: '36 jaar',
        37: '37 jaar',
        38: '38 jaar',
        39: '39 jaar',
        40: '40 jaar',
        41: '41 jaar',
        42: '42 jaar',
        43: '43 jaar',
        44: '44 jaar',
        45: '45 jaar',
        46: '46 jaar',
        47: '47 jaar',
        48: '48 jaar',
        49: '49 jaar',
        50: '50 jaar',
      },
      duration: 20,
      profile: 4,
      forehand: '0',
      dropdownlistType: false,
      dropdownlistDuration: false,
    };
  },
  created() {
    this.offerCalc();
  },
  watch: {
    type() {
      if(this.type == '0' || this.type == '2') {
        this.target = '';
      }
      this.offerCalc();
    },
    amount() {
      this.offerCalc();
    },
    urendement() {
      this.offerCalc();
    },
    forehand() {
      this.offerCalc();
    },
    style() {
      this.offerCalc();
    },
    profile() {
      this.offerCalc();
    },
    duration() {
      this.offerCalc();
    },
    target() {
      this.offerCalc();
    },
  },
  computed: {
    renderVerloop() {
      if (this.type === '1' || this.type === '4') {
        return this.calculation.verlopen.verloop;
      }
      if (this.type === '2') {
        return this.calculation.verlopen.verloop3;
      }
      return this.calculation.verlopen.verloop2;
    },
    quotationType() {
      if (this.type == '1') {
        return 'Leefrente';
      } else if (this.type == '4') {
        return 'Netto lijfrente';
      } else {
        return 'Uitkerende lijfrente';
      }
    },
    profiles() {
      if (this.style == 'db') {
        return [
          '0%',
          '1%',
          '2% - A',
          '3% - B',
          '4% - C',
          '5% - D',
          '6% - E',
          '7% - F',
          '8%',
          '9%',
          '10%',
        ];
      } else if (this.style == 'ox') {
        return [
          '0%',
          '1%',
          '2%',
          '3%',
          '4%',
          '5% - Laag',
          '6% - Midden',
          '7% - Hoog',
          '8%',
          '9%',
          '10%',
        ];
      }
      return [
        '0%',
        '1%',
        '2%',
        '3%',
        '4% - Zeer defensief',
        '5% - Defensief',
        '6% - Neutraal',
        '7% - Offensief',
        '8% - Zeer offensief',
        '9%',
        '10%',
      ];
    },
  },
  methods: {
    filter,
    offerCalc() {
      this.calculating = true;
      this.sdk.offerCalc(
        this.type,
        Number(this.amount),
        this.profile,
        this.duration,
        Number(this.urendement),
        this.forehand,
        this.target,
        (response) => {
          if (response.status === 200) {
            this.calculation = response.data;
          } else if (response.status === 410) {
            this.errorText = response.data.message;
          }
          this.calculating = false;
        }
      );
    },
    toInterval(period) {
      if (period === 'maand') {
        return 1;
      }
      if (period === 'kwartaal') {
        return 3;
      }
      if (period === 'halfjaar') {
        return 6;
      }
      return 12;
    },
    save() {
      console.log('saving');
      let initial = [];
      if (this.type == '1' || this.type == '4') {
        for (let i = 0; i < 51; i++) {
          if (this.calculation.polissen[i - (51 - Number(this.duration))]) {
            initial.push(this.calculation.polissen[i - (51 - Number(this.duration))]);
          } else {
            initial.push(0);
          }
        }
      } else {
        for (let i = 0; i < 51; i++) {
          if (51 - this.duration === i) {
            initial.push(Number(this.amount));
          } else {
            initial.push(0);
          }
        }
      }
      this.sdk.modifyPayouts(
        this.port,
        this.duration,
        this.urendement,
        JSON.stringify(initial),
        '[]',
        '[]',
        this.forehand,
        null,
        null,
        this.toInterval(this.paymentPeriod),
        '[]',
        (Number(this.profile) / 100) + 1,
        (response) => {
          if (response.status === 200) {
            alert('stored.');
          }
        },
      );
    },
  },
};
</script>
